import { useState, useCallback } from "react";
import { getSingleBundleReport } from "../../service/ReportingService";
import { showErrorMessage } from "../../components/shared/pagination/messages";

const useSingleBundleReport = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);

    const fetchReport = useCallback(async (bundleId, params = {}) => {
        if (!bundleId) return;
        setLoading(true);
        try {
            
            const cleanParams = {
                page: params.page ?? 0,
                size: params.size ?? 10,
                ...(params.subType     && { subType:  params.subType }),
                ...(params.status      && { status:   params.status }),
                ...(params.groupId     && { groupId:  params.groupId }),
                ...(params.userId      && { userId:   params.userId }),
                ...(params.search?.trim() && { search: params.search.trim() }),
            };

            const result = await getSingleBundleReport(bundleId, cleanParams);

            if (result.success) {
                setData(result.data);
                setTotal(result.data?.totalElements || 0);
                return result;
            } else {
                console.error(result.data);
                setData(null);
                setTotal(0);
            }
        } catch (error) {
            showErrorMessage("Failed to load bundle report");
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    return { data, loading, total, fetchReport };
};

export default useSingleBundleReport;